
export const StorageKey = {
  CSRF_TOKEN: 'pta_csrf_token'
}
